import React, { FC } from 'react';
import ICtaBoxWithDescription from '../../../interfaces/elements/ctaBoxWithDescription';
import { StyledRichText } from '../../base/richTextStyleWrapper/richTextStyleWrapper';
import { A } from '../../base/typography';
import * as StyledCtaBox from './ctaBoxWithDescription.styles';

interface Props {
	box: ICtaBoxWithDescription;
}

const CtaBoxWithDescription: FC<Props> = ({ box }) => {
	return (
		<StyledCtaBox.Wrapper>
			{box.Values.Image && <StyledCtaBox.BoxImage useCrop={false} image={box.Values.Image.Src} />}
			<StyledCtaBox.BoxContent>
				<StyledCtaBox.BoxTitle marginBottom="2rem">{box.Values.Title}</StyledCtaBox.BoxTitle>
				<StyledRichText content={box.Values.Content} />
				{box.Values.Link && <A to={box.Values.Link.Url}>{box.Values.Link.Name}</A>}
			</StyledCtaBox.BoxContent>
		</StyledCtaBox.Wrapper>
	);
};

export default CtaBoxWithDescription;
